import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { signOut } from '../auth/actions';
import { AppShell } from '../features/layout/AppShell';

export const Route = createFileRoute('/_authed')({ component: AuthedLayout });

function AuthedLayout(): React.JSX.Element {
  const navigate = useNavigate();
  const onAnonymous = useCallback(() => void navigate({ to: '/login' }), [navigate]);
  return (
    <AppShell onAnonymous={onAnonymous} onSignOut={() => void signOut()}>
      <Outlet />
    </AppShell>
  );
}
